// MUI
import { Button, Stack, Typography } from "@mui/material";

// Components
import AllDealsTable from "@DataPages/components/FniManagement/components/AllDeals/Tables/AllDealsTable.tsx";
import { CITDealsTableSectionSkeleton } from "@DataPages/layouts/financeManagement/skeletons/CITDealsTableSectionSkeleton";

// Types
import { IDeal } from "@Common/types/MyCit/model";
import { IPeriodTreeSelection } from "@Layouts/components/SideBars/PayPeriodSideBar/interfaces";

type TAllDealsTableSectionArgs = {
	// Header
	selectedPayPeriod: IPeriodTreeSelection;
	// Table Props
	data: IDeal[];
	hasNextPage: boolean;
	// Common
	isLoading: boolean;
	isFetching: boolean;
};
export function AllDealsTableSection(props: TAllDealsTableSectionArgs) {
	const { selectedPayPeriod, data, hasNextPage, isLoading, isFetching } = props;

	if (isLoading) {
		return <CITDealsTableSectionSkeleton />;
	}

	return (
		<Stack component={"section"} id={"f&i-all-deals-table"}>
			<Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
				<Typography variant="h2" component={"h2"} className={"page-title"}>
					{selectedPayPeriod?.titleExtended} Deals
				</Typography>
				<Button
					variant="contained"
					className={"h-[30px] !rounded-[6px] !font-sans !bg-primary !normal-case"}
					disableElevation
					onClick={() => {}}
				>
					Export as Excel
				</Button>
			</Stack>
			<AllDealsTable allDeals={data} hasNextPage={hasNextPage} isFetching={isFetching} />
		</Stack>
	);
}
